import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { IResponseContent } from "../models/interfaces/responseContent.interface";
import { IDeatilOperatorShift, IUpdateOperatorShift } from "../models/interfaces/operator-shift.interface";
import { IOperatorsOptions } from "../models/interfaces/typology.interface";

@Injectable({
  providedIn: 'root'
})

export class OperatorShiftService {
  
  private readonly _http = inject(HttpClient);

  detailOperator(id:number):Observable<IOperatorsOptions>{
    return this._http.get<IResponseContent<IOperatorsOptions>>(`/booking/operator/${id}`).pipe(
      map(({ content }) => content)
    );
  }

  detailOperatorShift(id: number): Observable<IDeatilOperatorShift[]> {
    return this._http.get<IResponseContent<IDeatilOperatorShift[]>>(`/booking/operator-shifts/${id}`).pipe(
      map(({ content }) => {
        return content.sort((a, b) => {
          const dateA = new Date(a.shiftDate).getTime();
          const dateB = new Date(b.shiftDate).getTime();
          return dateB - dateA; // ordine decrescente: dalla più recente alla più vecchia
        });
      })
    );
  }

  createOperatorShift(body:IUpdateOperatorShift):Observable<IResponseContent<any>>{
    return this._http.post<IResponseContent<any>>(`/booking/operator-shifts`,body);
  }

  editOperatorShift(body:IUpdateOperatorShift):Observable<IResponseContent<any>>{
    return this._http.put<IResponseContent<any>>(`/booking/operator-shifts/update-shifts`,body);
  }

  deleteOperatorShift(idOperator:number):Observable<IResponseContent>{
    return this._http.delete<IResponseContent>(`/booking/operator-shifts/${idOperator}`);
  }
}